<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="银行卡管理" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini">
								<el-form-item label="开户名称">
									<el-input v-model="searchForm.real_name" placeholder="请填写开户名称" clearable></el-input>
								</el-form-item>
								<el-form-item label="银行卡号">
									<el-input v-model="searchForm.bank_card_num" placeholder="请填写银行卡号" clearable></el-input>
								</el-form-item>
								<el-form-item label="关联类型">
									<el-select v-model="searchForm.relevance" placeholder="请选择" clearable style="width: 100%;">
										<el-option label="供应商" :value="1"></el-option>
										<el-option label="客户" :value="2"></el-option>
										<el-option label="平台" :value="3"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="银行卡类型">
									<el-select v-model="searchForm.pay_type" placeholder="请选择" clearable style="width: 100%;">
										<el-option label="对公" :value="1"></el-option>
										<el-option label="对私" :value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="状态">
									<el-select v-model="searchForm.status" placeholder="请选择" style="width: 100%;" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="是否停用">
									<el-select v-model="searchForm.is_disable" placeholder="请选择" style="width: 100%;" clearable>
										<el-option v-for="item in options.is_disable_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="创建日期">
									<el-date-picker clearable align="center" v-model="searchForm.create_time" type="daterange"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期"></el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
									<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/customers/customer/createbankcard') || $parent.$parent.isAuthAction('admin/customers/export/exportbankcardexcel')">
								<div>
									<el-button type="primary" size="mini" @click="addBankcardOpen"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/createbankcard')">添加银行卡</el-button>
								</div>
								<div style="margin-right:10px">
									<el-link type="primary" icon="el-icon-download" :disabled="isDownloading" @click="exportData"
										v-if="$parent.$parent.isAuthAction('admin/customers/export/exportbankcardexcel')">{{ isDownloading ?
											'下载中...' : '下载' }}</el-link>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" row-key="id" border stripe ref="table"
									v-loading="tableloading" highlight-current-row :height="tableHeight">
									<el-table-column fixed prop="id" label="ID" width="50">
									</el-table-column>
									<el-table-column fixed prop="relevance_txt" label="类型" width="100">
									</el-table-column>
									<el-table-column fixed prop="pay_type_txt" label="银行卡类型" width="90">
									</el-table-column>
									<el-table-column fixed label="银行卡信息" min-width="350">
										<template slot-scope="scope">
											<p style="font-weight: bold;">开户名称：<el-link type="primary"
													style="font-size: 12px; text-decoration: underline;" :underline="false"
													@click="detail(scope.row)" target="_blank">{{ scope.row.real_name }}</el-link></p>
											<p style="font-weight: bold;">开&nbsp;户&nbsp;行&nbsp;：{{ scope.row.bankcard_of_deposit_txt }}</p>
											<p style="font-weight: bold;">支&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;行：{{
												scope.row.bankcard_branch_txt }}</p>
											<p style="font-weight: bold;">银行卡号：{{ scope.row.bank_card_num }}</p>
										</template>
									</el-table-column>
									<!-- <el-table-column fixed prop="real_name" label="开户名称" min-width="250">
										<template slot-scope="scope">
											<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click="detail(scope.row)" target="_blank">{{ scope.row.real_name }}</el-link>
										</template>
									</el-table-column> -->

									<!-- <el-table-column prop="bankcard_of_deposit" label="开户行及支行" :show-overflow-tooltip="true"
										min-width="250">
										<template slot-scope="scope">
											{{ scope.row.bankcard_of_deposit_txt }}{{ scope.row.bankcard_branch_txt }}
										</template>
									</el-table-column> -->
									<!-- <el-table-column prop="bank_card_num" label="银行卡号" width="200">
									</el-table-column> -->
									<el-table-column prop="bank_prove" label="开户证明" align="center" width="80">
										<template slot-scope="scope">
											<el-link type="primary" :href="scope.row.bank_prove" target="_blank" style="font-size: 12px;"
												v-if="scope.row.bank_prove">预览</el-link>
											<span v-else>--</span>
										</template>
									</el-table-column>
									<el-table-column prop="bank_prove" label="关联证明" align="center" width="80">
										<template slot-scope="scope">
											<el-link type="primary" :href="scope.row.guanlian_prove" target="_blank" style="font-size: 12px;"
												v-if="scope.row.guanlian_prove">预览</el-link>
											<span v-else>--</span>
										</template>
									</el-table-column>
									<el-table-column prop="rid_txt" label="客户/供应商/平台" :show-overflow-tooltip="true" min-width="200">
									</el-table-column>
									<el-table-column prop="uid_txt" label="创建人" width="80">
									</el-table-column>
									<el-table-column prop="create_time" label="创建时间" width="160">
									</el-table-column>
									<el-table-column prop="update_time" label="修改时间" width="160">
									</el-table-column>
									<el-table-column prop="is_disable_txt" label="是否启用" width="80">
										<template slot-scope="scope">
											<span style="font-weight: bold;" :style="{ color: scope.row.is_disable_txt === '启用' ? '#67C23A' : '#F56C6C' }">{{ scope.row.is_disable_txt }}</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" prop="is_default" label="是否默认" align="center" width="80">
										<template slot-scope="scope">
											<span v-if="scope.row.is_default == 1">是</span>
											<span v-if="scope.row.is_default == 0">否</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" prop="status_txt" align="center" label="状态" width="80">
										<template slot-scope="scope">
											<span style="font-weight: bold;">{{ scope.row.status_txt }}</span>
										</template>
									</el-table-column>
									<el-table-column fixed="right" label="操作" width="220">
										<template slot-scope="scope">
											<el-button :disabled="scope.row.status != 4" @click="handleTableDisableOpen(scope.row)"
												type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/disablecard')">{{
													scope.row.is_disable == 2 ? '启用' : '停用' }}</el-button>
											<template v-if="scope.row.status == 1 || scope.row.status == 3">
												<el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/updatebankcard')">编辑</el-button>
												<el-button @click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/delbankcard')">删除</el-button>
												<el-button @click="handleTableFlow(scope.row)" type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/confirmsubmitbankcard')">提交审批</el-button>
											</template>
											<template v-else>
												<el-button @click="updateName(scope.row.id)" type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/updatebankcardname')">变更信息</el-button>
												<el-button disabled type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/updatebankcard')">编辑</el-button>
												<el-button disabled type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/delbankcard')">删除</el-button>
												<el-button disabled type="text" :size="size"
													v-if="$parent.$parent.isAuthAction('admin/customers/customer/confirmsubmitbankcard')">提交审批</el-button>
											</template>
											<el-button
												:disabled="!(scope.row.status == 4 && scope.row.is_default == 0 && scope.row.is_disable == 1)"
												@click="isDefault(scope.row)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/bankcarddefult')">设置默认</el-button>

										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--添加银行卡-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" v-loading="loading"
			:close-on-press-escape='false' :wrapperClosable='false' size="60%">
			<div class="drawer-header">
				<div class="header-title">
					<span>添加银行卡</span>
					<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
				</div>
			</div>
			<div class="drawer-content">
				<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
					<div>
						<el-form-item label="关联类型" key="relevance" prop="relevance">
							<el-select v-model="addForm.relevance" placeholder="请选择" clearable style="width: 100%;"
								@change="getRid()">
								<el-option label="供应商" :value="1"></el-option>
								<el-option label="客户" :value="2"></el-option>
								<el-option label="平台" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="addForm.ridLable" key="rid" v-if="addForm.relevance" prop="rid">
							<el-select v-model="addForm.rid" placeholder="请选择" clearable style="width: 100%;" filterable remote
								reserve-keyword :remote-method="getRid">
								<el-option v-for="item in options.rid_options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="支付方式" key="pay_type" prop="pay_type">
							<el-select v-model="addForm.pay_type" placeholder="请选择" clearable style="width: 100%;">
								<el-option label="对公" :value="1"></el-option>
								<el-option label="对私" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="开户名称" prop="real_name">
							<el-input v-model="addForm.real_name" placeholder="请填写开户名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="银行卡号" prop="bank_card_num">
							<el-input v-model="addForm.bank_card_num" placeholder="请填写银行卡号" clearable></el-input>
						</el-form-item>
						<el-form-item label="开户行及支行" prop="bankcard_branch" key="bankcard_branch">
							<el-col :span="11">
								<el-select v-model="addForm.bankcard_of_deposit" filterable
									@change="requestZh(addForm.bankcard_of_deposit, 'clear')" placeholder="请选择开户行" clearable
									style="width: 100%;">
									<el-option v-for="item in options.khh_options" :key="item.id" :label="item.bank_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-col>
							<el-col class="line" style="width:20px; text-align: center;">-</el-col>
							<el-col :span="12">
								<el-select v-model="addForm.bankcard_branch" filterable allow-create default-first-option
									placeholder="请选择支行" clearable style="width: 100%;">
									<el-option v-for="item in options.zh_options" :key="item.id" :label="item.bank_name" :value="item.id">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="开户证明" prop="bank_prove" key="invoice_prove" v-if="addForm.relevance == 1">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.bank_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'addForm', 'bank_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'addForm', 'bank_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="关联证明" key="guanlian_prove" v-if="addForm.relevance == 1 || addForm.relevance == 2">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.guanlian_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'addForm', 'guanlian_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'addForm', 'guanlian_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button type="primary" @click="addBankcard()" :size='size' :disabled="bankcardSubmitDisabled">提交</el-button>
				<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
			</div>
		</el-drawer>
		<!--编辑银行卡-->
		<el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" v-loading="loading"
			:close-on-press-escape='false' :wrapperClosable='false' size="60%">
			<div class="drawer-header">
				<div class="header-title">
					<span>编辑银行卡</span>
					<i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
				</div>
			</div>
			<div class="drawer-content">
				<el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px">
					<div>
						<el-form-item label="关联类型" key="relevance" prop="relevance">
							<el-select v-model="editForm.relevance" placeholder="请选择" clearable style="width: 100%;"
								@change="getRidedit('clear')">
								<el-option label="供应商" :value="1"></el-option>
								<el-option label="客户" :value="2"></el-option>
								<el-option label="平台" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="editForm.ridLable" key="rid" v-if="editForm.relevance" prop="rid">
							<el-select v-model="editForm.rid" placeholder="请选择" style="width: 100%;" clearable filterable remote
								reserve-keyword :remote-method="(query) => getRidedit('clear', query)">
								<el-option v-for="item in options.rid_options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="支付方式" key="pay_type" prop="pay_type">
							<el-select v-model="editForm.pay_type" placeholder="请选择" clearable style="width: 100%;">
								<el-option label="对公" :value="1"></el-option>
								<el-option label="对私" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="开户名称" prop="real_name">
							<el-input v-model="editForm.real_name" placeholder="请填写开户名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="银行卡号" prop="bank_card_num">
							<el-input v-model="editForm.bank_card_num" placeholder="请填写银行卡号" clearable></el-input>
						</el-form-item>
						<el-form-item label="开户行及支行" prop="bankcard_branch" key="bankcard_branch">
							<el-col :span="11">
								<el-select v-model="editForm.bankcard_of_deposit" filterable
									@change="requestZh(editForm.bankcard_of_deposit, 'clear')" placeholder="请选择开户行" clearable
									style="width: 100%;">
									<el-option v-for="item in options.khh_options" :key="item.id" :label="item.bank_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-col>
							<el-col class="line" style="width:20px; text-align: center;">-</el-col>
							<el-col :span="12">
								<el-select v-model="editForm.bankcard_branch" filterable allow-create default-first-option
									placeholder="请选择支行" clearable style="width: 100%;">
									<el-option v-for="item in options.zh_options" :key="item.id" :label="item.bank_name" :value="item.id">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="开户证明" prop="bank_prove" key="invoice_prove" v-if="editForm.relevance == 1">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="editForm.bank_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'editForm', 'bank_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'editForm', 'bank_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="关联证明" key="guanlian_prove" v-if="editForm.relevance == 1 || editForm.relevance == 2">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="editForm.guanlian_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'editForm', 'guanlian_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'editForm', 'guanlian_prove', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button type="primary" @click="handleTableEdit()" :size='size' :disabled="bankcardSubmitDisabled">提交</el-button>
				<el-button :size='size' @click="editFormVisiable = false">取消</el-button>
			</div>
		</el-drawer>
		<el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			dialogImageUrl: '',
			dialogVisibleImg: false,
			isDownloading: false,
			bankcardSubmitDisabled: false,
			addFormVisiable: false,
			editFormVisiable: false,
			loading: true,
			tableloading: true,
			activeName: 'first',
			size: 'mini',
			options: {
				is_disable_options: [
					{
						value: 1,
						label: '启用'
					}, {
						value: 2,
						label: '停用'
					}],
				status_options: [
					{
						value: 1,
						label: '待提交'
					}, {
						value: 2,
						label: '待审核'
					}, {
						value: 3,
						label: '被驳回'
					}, {
						value: 4,
						label: '正常'
					}],
				khh_options: [],//开户行-开票信息
				zh_options: [],//支行-开票信息
				rid_options: []//供应商/客户
			},
			searchForm: {
				real_name: '',
				bank_card_num: '',
				relevance: '',
				pay_type: '',
				status: '',
				is_disable: '',
				create_time: []
			},
			resetSearch: {
				real_name: '',
				bank_card_num: '',
				relevance: '',
				pay_type: '',
				status: '',
				is_disable: '',
				create_time: []
			},
			addForm: {
				relevance: '',
				rid: '',
				ridLable: '',
				pay_type: '',
				real_name: '',
				bank_card_num: '',
				bankcard_of_deposit: '',
				bankcard_branch: '',
				bank_prove: [],
				guanlian_prove: []
			},
			editForm: {
				relevance: '',
				rid: '',
				ridLable: '',
				pay_type: '',
				real_name: '',
				bank_card_num: '',
				bankcard_of_deposit: '',
				bankcard_branch: '',
				bank_prove: [],
				guanlian_prove: []
			},
			rules: {
				addForm: {
					'relevance': [
						{ required: true, message: '请选择关联类型', trigger: ['change'] }
					],
					'rid': [
						{ required: true, message: '请选择', trigger: ['change'] }
					],
					'pay_type': [
						{ required: true, message: '请选择支付方式', trigger: ['change'] }
					],
					'real_name': [
						{ required: true, message: '请填写开户名称', trigger: ['blur'] }
					],
					'bank_card_num': [
						{
							required: true, validator: (rule, value, callback) => {
								const regex = /^\d+(\.\d+)?$/; // 匹配整数或浮点数
								if (!value) {
									callback(new Error('请填写银行卡号'));
								} else {
									if (!regex.test(value)) {
										callback(new Error('请填写正确的银行卡号'));
									} else {
										callback();
									}
								}
							}, trigger: ['change', 'blur']
						}
					],
					'bankcard_branch': [
						{
							required: true, validator: (rule, value, callback) => {
								if (!this.addForm.bankcard_of_deposit) {
									callback(new Error('请选择开户行'));
								} else if (!this.addForm.bankcard_branch) {
									callback(new Error('请选择支行'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'bank_prove': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.addForm.bank_prove.length < 1 && this.addForm.relevance == 1) {
									callback(new Error('请上传开户证明'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				},
				editForm: {
					'relevance': [
						{ required: true, message: '请选择关联类型', trigger: ['change'] }
					],
					'rid': [
						{ required: true, message: '请选择', trigger: ['change'] }
					],
					'pay_type': [
						{ required: true, message: '请选择支付方式', trigger: ['change'] }
					],
					'real_name': [
						{ required: true, message: '请填写开户名称', trigger: ['blur'] }
					],
					'bank_card_num': [
						{
							required: true, validator: (rule, value, callback) => {
								const regex = /^\d+(\.\d+)?$/; // 匹配整数或浮点数
								if (!value) {
									callback(new Error('请填写银行卡号'));
								} else {
									if (!regex.test(value)) {
										callback(new Error('请填写正确的银行卡号'));
									} else {
										callback();
									}
								}
							}, trigger: ['change', 'blur']
						}
					],
					'bankcard_branch': [
						{
							required: true, validator: (rule, value, callback) => {
								if (!this.editForm.bankcard_of_deposit) {
									callback(new Error('请选择开户行'));
								} else if (!this.editForm.bankcard_branch) {
									callback(new Error('请选择支行'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					],
					'bank_prove': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.editForm.bank_prove.length < 1 && this.editForm.relevance == 1) {
									callback(new Error('请上传开户证明'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			}
		}
	},
	computed: {
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	mounted: function () {
		//this.handleSearch(this.searchForm);
		this.requestKhh()//获取开户行
	},
	methods: {
		updateName (id) {
			this.$api.get('/admin/customers/customer/getbankcard', { 'id': id }).then(res => {
				if (res.code == 0) {
					this.$prompt('请输入新的开户名称', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						inputValue: res.data.real_name,
						inputValidator: (value) => {
							// 必填验证
							if (!value || value.trim() === '') {
								return '开户名称不能为空';
							}
							// 验证通过返回 true
							return true;
						},
						inputErrorMessage: '请正确填写开户名称'
					}).then(({ value }) => {
						this.$api.post('/admin/customers/customer/updatebankcardname', { 'id': id, 'real_name': value }).then(res_invoice => {
							if (res_invoice.code == 0) {
								this.$message({
									type: 'success',
									message: `修改成功`
								});
								this.handleSearch();
							} else {
								this.$message({
									type: 'error',
									message: res_invoice.msg
								});
							}
						})
					})
				}
			})
		},
		handleTableDisableOpen (row) {
			let txt = ''
			let is_disable_value = ''
			if (row['is_disable'] == 1) {
				txt = '停用'
				is_disable_value = 2
			} else {
				txt = '启用'
				is_disable_value = 1
			}
			this.$confirm(`此操作将【${txt}】该银行卡信息, 是否继续?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$api.post('/admin/resources/resources/disablecard', { id: row['id'], is_disable: is_disable_value }).then(res => {
					if (res.code == 0) {
						this.tableData.data.forEach((item, index) => {
							if (item['id'] == row['id']) {
								this.$set(this.tableData.data[index], 'is_disable', is_disable_value)
								this.$set(this.tableData.data[index], 'is_disable_txt', txt)
							}
						})
						this.$message({
							type: 'success',
							message: `${txt}成功!`
						});
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						});
					}
				})
			})
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		exportData () {
			this.isDownloading = true;
			var excelSearch = JSON.parse(JSON.stringify(this.searchForm))
			excelSearch.downloadType = 'bankcard'
			this.$api.get('/admin/customers/export/exportbankcardexcel', excelSearch).then(res => {
				// if (res.code == 0) {
				// 		this.$alert('异步下载任务【银行卡列表下载】创建成功！请稍后查看下载列表', '下载提示', {
				// 			confirmButtonText: '确定',
				// 		});
				// }else{
				// 	this.$message({
				// 		type: 'error',
				// 		message: res.msg
				// 	});
				// }
				// this.isDownloading = false;
				// 将Blob转换为URL以便创建一个可下载的链接
				const url = window.URL.createObjectURL(new Blob([res]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', '银行卡信息.xlsx'); // 设置下载文件名
				document.body.appendChild(link);
				link.click(); // 触发点击下载
				document.body.removeChild(link); // 下载后移除元素
				window.URL.revokeObjectURL(url); // 释放URL对象
				this.isDownloading = false
				this.$alert('您所下载的Excel数据已完毕,请查收！', '下载提示', {
					confirmButtonText: '确定',
				});
			})
		},
		isDefault (row) {
			this.$api.post('/admin/customers/customer/bankcarddefult', { id: row.id }).then(res => {
				if (res.code == 0) {
					var data = this.tableData.data
					data.forEach(function (item, index) {
						if (item.id == row.id) {
							if (item.is_default == 1) {
								this.$set(data[index], 'is_default', 0)
							} else {
								this.$set(data[index], 'is_default', 1)
							}
						}
					}.bind(this))
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//列表查询
		handleSearch (params, page, prop, order) {
			this.tableloading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/customers/customer/getbankcardlist', param).then(res => {
				if (res.code == 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.tableloading = false;
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		// 添加银行卡弹窗
		addBankcardOpen () {
			this.addForm = {
				relevance: '',
				rid: '',
				pay_type: '',
				real_name: '',
				bank_card_num: '',
				bankcard_of_deposit: '',
				bankcard_branch: '',
				bank_prove: [],
				guanlian_prove: []
			}
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.addFormVisiable = true;
		},
		// 添加银行卡
		addBankcard () {
			if (this.bankcardSubmitDisabled) return;
			// 先置灰，防止 validate 异步期间用户重复点击
			this.bankcardSubmitDisabled = true;
			const formData = new FormData()
			for (const key in this.addForm) {
				if ((key == 'bank_prove' || key == 'guanlian_prove') && [1, 2].indexOf(this.addForm.relevance) != -1) {
					if (this.addForm[key].length > 0) {
						this.addForm[key].forEach(item => {
							formData.append(key, item)
						})
					} else {
						formData.append(key, '')
					}
				} else {
					formData.append(key, this.addForm[key]);
				}
			}
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/customers/customer/createbankcard', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '银行卡添加成功！',
								type: 'success'
							});
							this.addFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
						this.bankcardSubmitDisabled = false;
					}).catch(() => {
						this.loading = false;
						this.bankcardSubmitDisabled = false;
					})
				} else {
					// 校验失败也需要释放按钮
					this.bankcardSubmitDisabled = false;
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		// 打开编辑银行卡弹窗
		handleTableEditOpen (row) {
			this.$api.get('/admin/customers/customer/getbankcard', { id: row.id }).then(res => {
				if (res.code === 0) {
					this.editForm = res.data
					if (this.editForm.relevance) {
						this.getRidedit()
					}
					if (this.editForm.bankcard_of_deposit) {
						this.requestKhh()
						this.requestZh(this.editForm.bankcard_of_deposit, 'keep')
					}
					this.editFormVisiable = true;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 编辑银行卡
		handleTableEdit () {
			if (this.bankcardSubmitDisabled) return;
			// 先置灰，防止 validate 异步期间用户重复点击
			this.bankcardSubmitDisabled = true;
			const formData = new FormData()
			for (const key in this.editForm) {
				if ((key == 'bank_prove' || key == 'guanlian_prove') && [1, 2].indexOf(this.editForm.relevance) != -1) {
					if (this.editForm[key].length > 0) {
						this.editForm[key].forEach(item => {
							formData.append(key, item)
						})
					} else {
						formData.append(key, '')
					}
				} else {
					formData.append(key, this.editForm[key]);
				}
			}
			this.$refs['editForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/customers/customer/updatebankcard', formData).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch('', this.tableData.page);
							this.$message({
								showClose: true,
								message: '银行卡信息修改成功！',
								type: 'success'
							});
							this.editFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
						this.bankcardSubmitDisabled = false;
					}).catch(() => {
						this.loading = false;
						this.bankcardSubmitDisabled = false;
					})
				} else {
					// 校验失败也需要释放按钮
					this.bankcardSubmitDisabled = false;
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		// 删除银行卡
		handleTableDelete (row) {
			this.$confirm('此操作将永久删除该银行卡, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/customers/customer/delbankcard', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该银行卡已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//获取开户行
		requestKhh () {
			this.$api.get('/admin/resources/resources/getbankname').then(res => {
				if (res.code === 0) {
					this.options.khh_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取支行
		requestZh (id, changetype) {
			//changetype为clear则清空关联，keep为编辑状态下默认的值不清空
			if (changetype == 'clear') {
				this.addForm.bankcard_branch = '';
				this.editForm.bankcard_branch = '';
			}
			this.$api.get('/admin/resources/resources/getbankname', { id: id }).then(res => {
				if (res.code === 0) {
					this.options.zh_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//点击查看大图
		viewImg (file) {
			if (!file.path) {
				//还未上传
				let url = URL.createObjectURL(file)
				if (file.name.includes('.pdf')) {
					window.open(url)
				} else {
					this.dialogImageUrl = url;
					this.dialogVisibleImg = true;
				}

			} else {
				//已上传
				if (file.name.includes('.pdf')) {
					window.open(file.path)
				} else {
					this.dialogImageUrl = file.path;
					this.dialogVisibleImg = true;
				}
			}
		},
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = [file.raw]
			} else {
				this[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this[formobj][field] = []
			} else {
				this[formobj][field].forEach(function (item, index) {
					if (item.name == file.name) {
						this.$delete(this[formobj][field], index)
					}
				}.bind(this))
			}

		},
		getRid (query) {
			if (query) {
				var map = { query: query }
			}
			if (this.addForm.relevance == 1) {
				this.addForm.ridLable = '供应商'
				this.$api.get('/admin/resources/resources/supldwn', map).then(res => {
					if (res.code === 0) {
						this.options.rid_options = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			} else if (this.addForm.relevance == 2) {
				this.addForm.ridLable = '客户'
				this.$api.get('/admin/customers/customer/getcustomerselect', map).then(res => {
					if (res.code === 0) {
						this.options.rid_options = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			} else if (this.addForm.relevance == 3) {
				this.addForm.ridLable = '平台'
				this.$api.get('/admin/resources/resources/platformdwn', map).then(res => {
					if (res.code === 0) {
						this.options.rid_options = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			}
			this.addForm.rid = ''
			this.addForm.guanlian_prove = []
		},
		getRidedit (type, query) {
			if (query) {
				var map = { query: query }
			}
			if (this.editForm.relevance == 1) {
				this.editForm.ridLable = '供应商'
				this.$api.get('/admin/resources/resources/supldwn', map).then(res => {
					if (res.code === 0) {
						this.options.rid_options = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			} else if (this.editForm.relevance == 2) {
				this.editForm.ridLable = '客户'
				this.$api.get('/admin/customers/customer/getcustomerselect', map).then(res => {
					if (res.code === 0) {
						this.options.rid_options = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			} else if (this.editForm.relevance == 3) {
				this.editForm.ridLable = '平台'
				this.$api.get('/admin/resources/resources/platformdwn', map).then(res => {
					if (res.code === 0) {
						this.options.rid_options = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
			}
			if (type == 'clear') {
				this.editForm.rid = ''
				this.editForm.bank_prove = []
				this.editForm.guanlian_prove = []
			}
		},
		//提交审批
		handleTableFlow (row) {
			this.$api.post('/admin/customers/customer/confirmsubmitbankcard', { id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该银行卡信息已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'BankcardDetail',
				query: { id: row.id, set_id: 11, type: 'detail' }
			});
		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			// 使用 === 进行严格相等判断
			if (from.path !== '/bankcardDetail') {
				try {
					vm.reset();
				} catch (error) {
				}
			}
		});
	}
}
</script>